import { errorMetricsColors, metricsColors } from "../../../consts";
import { arrayUtil } from "../../../utils";

const getColorsConfig = (metricsConfig) => {
  const colorsConfig = {};

  metricsConfig &&
    Object.keys(metricsConfig).map((metric) => {
      if (metricsConfig[metric]?.color) {
        colorsConfig[metric] = metricsConfig[metric]?.color;
      }
    });

  return colorsConfig;
};

const updateColorsOrder = (metrics, metricsConfig, isErrorColors) => {
  const metricsColorsConfig = getColorsConfig(metricsConfig);

  let colors = isErrorColors ? Object.values(errorMetricsColors) : Object.values(metricsColors);

  if (metricsColorsConfig) {
    metrics &&
      metrics?.map((metric, index) => {
        const i = index % colors.length >= 0 ? index % colors.length : index;
        if (metricsColorsConfig[metric] && colors.indexOf(metricsColorsConfig[metric]) !== -1) {
          colors = swapColors(colors, metricsColorsConfig[metric], i);
        }
      });
  }

  return colors;
};

const swapColors = (colors, colorValue, currentIndex) => {
  const newColorIndex = colors.indexOf(colorValue);
  const result = arrayUtil.swapElements(colors, currentIndex, newColorIndex);

  return result;
};

const getColor = (colors, index, metric, metricsConfig) => {
  const metricsColorsConfig = getColorsConfig(metricsConfig);

  const i = index % colors.length >= 0 ? index % colors.length : index;
  const color =
    metricsColorsConfig && metricsColorsConfig[metric] ? metricsColorsConfig[metric] : colors[i];

  return color;
};

const metricsColorHelpers = {
  updateColorsOrder,
  getColor
};

export default metricsColorHelpers;
